export default __webpack_public_path__ + "static/media/gallery_12.cfc467d6.jpg";